import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import LanderHeader from "../../general/include/LanderHeader";
import { resetPassword, checkPasswordToken } from "../../../services/user";
import PageExpired from "../messages/PageExpired";
import Waiting from "../../utilities/Waiting";
import { Link } from "react-router-dom";

export class ResetPassword extends Component {
    state = {
        validToken: true,
        item: {},
        errors: {},
        waiting: true
    };

    componentDidMount() {
        checkPasswordToken({ token: this.props.match.params["token"] })
            .then(res => {
                if (res.status === true) {
                    this.setState({
                        item: { token: this.props.match.params["token"] },
                        waiting: false
                    });
                    this.nameInput.focus();
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false, waiting: false });
            });
    }

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    };
    submitPassword = e => {
        e.preventDefault();
        resetPassword(this.state.item)
            .then(res => {
                this.props.history.push("/login");
            })
            .catch(error => {
                switch (error.response.status) {
                    case 422:
                        this.setState({
                            errors: error.response.data.error
                        });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };

    render() {
        return (
            <Fragment>
                {this.state.waiting === false ? (
                    <Fragment>
                        {this.state.validToken === true ? (
                            <Fragment>
                                <LanderHeader></LanderHeader>
                                <div className="container-fluid reset pt-5 mt-5">
                                    <div className="row">
                                    <div className="auth-container  align-self-center">
                                        <div className="register-padding">
                                            <h1 className="display-4 text-center mb-3">
                                                Reset your password
                                            </h1>
                                            <p className="text-muted text-center mb-5">
                                                Enter your new password
                                            </p>
                                            <form
                                                onSubmit={this.submitPassword}
                                                method="POST"
                                            >
                                                <div className="form-group">
                                                    <label htmlFor="password">
                                                        Password
                                                    </label>
                                                    <input
                                                        ref={input => {
                                                            this.nameInput = input;
                                                        }}
                                                        id="password"
                                                        type="password"
                                                        value={
                                                            this.state.item
                                                                .password
                                                        }
                                                        onChange={this.onChange}
                                                        name="password"
                                                        className={
                                                            this.state.errors
                                                                .password_confirmation
                                                                ? "is-invalid form-control  form-control-large"
                                                                : " form-control  form-control-large"
                                                        }
                                                    />
                                                    {this.state.errors
                                                        .password ? (
                                                        <div className="invalid-feedback">
                                                            {
                                                                this.state
                                                                    .errors
                                                                    .password
                                                            }
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="form-group">
                                                    <label
                                                        className="bold"
                                                        htmlFor="password_confirmation"
                                                    >
                                                        Password confirmation
                                                    </label>
                                                    <input
                                                        id="password_confirmation"
                                                        type="password"
                                                        value={
                                                            this.state.item
                                                                .password_confirmation
                                                        }
                                                        onChange={this.onChange}
                                                        name="password_confirmation"
                                                        className={
                                                            this.state.errors
                                                                .password_confirmation
                                                                ? "is-invalid form-control  form-control-large"
                                                                : " form-control  form-control-large"
                                                        }
                                                    />
                                                    {this.state.errors
                                                        .password_confirmation ? (
                                                        <div className="invalid-feedback">
                                                            {
                                                                this.state
                                                                    .errors
                                                                    .password_confirmation
                                                            }
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <button className="form-control-large bold btn btn-lg btn-block btn-primary mb-3 mt-5">
                                                    Reset Password
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </Fragment>
                        ) : (
                            <PageExpired></PageExpired>
                        )}
                    </Fragment>
                ) : (
                    <Waiting></Waiting>
                )}
            </Fragment>
        );
    }
}

ResetPassword.contextType = AppContext;
export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/auth/password/ResetPassword.js